export const Urls = {
  BACKEND_URL: "https://gudkuchebehnhkslpo2t3v7jvu0kgipe.lambda-url.ap-south-1.on.aws",
  // BACKEND_URL: "https://besoman-backend.onrender.com",

  IMAGE_URL: "https://s3.tebi.io/besoman/",
  // Add more URLs here
};
